import React, { useEffect, useMemo, useState } from 'react';
import Header from '../components/layout/Header';
import GalleryGrid from '../components/features/GalleryGrid';
import { Skeleton } from '../components/ui/Skeleton';
import { api } from '../services/api';
import { cn } from '../lib/utils';

const TABS = [
  { id: 'all', label: 'Todos' },
  { id: 'celula', label: 'Células' },
  { id: 'rede', label: 'Redes' },
  { id: 'evento', label: 'Eventos' },
];

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('all');

  useEffect(() => {
    api.getGallery().then((g) => {
      setItems(g);
      setLoading(false);
    });
  }, []);

  const filtered = useMemo(
    () => (tab === 'all' ? items : items.filter((i) => i.category === tab)),
    [items, tab]
  );

  return (
    <div>
      <Header title="Galeria" subtitle="Momentos da nossa comunidade" />

      <div className="sticky top-0 z-20 bg-canvas/95 py-3 backdrop-blur-lg md:top-16">
        <div className="app-container">
          <div className="flex gap-2 rounded-full border border-slate-200 bg-white p-1 md:max-w-md" data-testid="gallery-tabs">
            {TABS.map((t) => (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                data-testid={`gallery-tab-${t.id}`}
                className={cn(
                  'flex-1 rounded-full py-2 text-sm font-semibold font-heading transition-colors duration-200',
                  tab === t.id ? 'bg-primary text-white shadow-soft' : 'text-ink-soft hover:text-primary'
                )}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="app-container py-4">
        {loading ? (
          <div className="columns-2 gap-3 md:columns-3 xl:columns-4">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className={cn('mb-3 w-full', i % 2 ? 'h-40' : 'h-56')} />
            ))}
          </div>
        ) : (
          <GalleryGrid items={filtered} />
        )}
      </div>

    </div>
  );
}
